/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Hideonwebsite2Inputs */

const de__field_hideonwebsite2 = /** @type {(inputs: _Field_Hideonwebsite2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kooperationspartner ist auf der CHANCENwerk-Webseite versteckt`)
};

/**

* @param {_Field_Hideonwebsite2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_hideonwebsite2 = /** @type {((inputs?: _Field_Hideonwebsite2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Hideonwebsite2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_hideonwebsite2(inputs)
});
export { _field_hideonwebsite2 as "_field_hideOnWebsite" }